var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import Select from "react-select";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "./di/serviceLocator";
import { ZeroisingPopUpdropdownList, zeroisingPopUpRadioList, } from "./constant";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import Loader from "@frameworks/shared-library/components/Loader";
var TentativeOrFinalPopUp = function (props) {
    var _a = __read(useState(), 2), selectedDropdownValue = _a[0], setSelectedDropdownValue = _a[1];
    var _b = __read(useState(), 2), selectedRadioValue = _b[0], setSelectedRadioValue = _b[1];
    var _c = __read(useState(false), 2), dropdownError = _c[0], setDropdownError = _c[1];
    var _d = __read(useState(false), 2), radioButtonError = _d[0], setRadioButtonError = _d[1];
    var _e = __read(useState(false), 2), loader = _e[0], setLoader = _e[1];
    var _f = __read(useState(""), 2), message = _f[0], setMessage = _f[1];
    var _g = __read(useState(false), 2), isSucess = _g[0], setIsSucess = _g[1];
    var getIbeatsData = function () {
        setLoader(true);
        di.salesReporting
            .getZeroisingReportIbeats({
            EqCo: selectedDropdownValue.value.toString(),
            tentativeFinal: selectedRadioValue.value.toString(),
        })
            .then(function (resp) {
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.message)) {
                setMessage(resp === null || resp === void 0 ? void 0 : resp.message);
                setIsSucess(resp === null || resp === void 0 ? void 0 : resp.isSucess);
            }
            setLoader(false);
        })
            .catch(function (err) {
            setLoader(false);
        });
    };
    var getViewData = function () {
        setLoader(true);
        di.salesReporting
            .getZeroisingPopUpView({
            EqCo: selectedDropdownValue.value.toString(),
            tentativeFinal: selectedRadioValue.value.toString(),
        })
            .then(function (resp) {
            if (resp) {
                if (resp === null || resp === void 0 ? void 0 : resp.base64) {
                    base64toExcel(resp === null || resp === void 0 ? void 0 : resp.base64, "Zeroising_View" + ".csv");
                }
                if (resp === null || resp === void 0 ? void 0 : resp.message) {
                    setMessage(resp === null || resp === void 0 ? void 0 : resp.message);
                    setIsSucess(resp === null || resp === void 0 ? void 0 : resp.isSucess);
                }
            }
            setLoader(false);
        })
            .catch(function (err) {
            setLoader(false);
        });
    };
    var getPublishData = function () {
        setLoader(true);
        di.salesReporting
            .getZeroisingPopUpPublish({
            EqCo: selectedDropdownValue.value.toString(),
            tentativeFinal: selectedRadioValue.value.toString(),
        })
            .then(function (resp) {
            setLoader(false);
        })
            .catch(function (err) {
            setLoader(false);
        });
    };
    var handleButtonClick = function (button) {
        if (selectedRadioValue &&
            selectedDropdownValue &&
            (selectedRadioValue === null || selectedRadioValue === void 0 ? void 0 : selectedRadioValue.value) &&
            (selectedDropdownValue === null || selectedDropdownValue === void 0 ? void 0 : selectedDropdownValue.value)) {
            button === "ibeats"
                ? getIbeatsData()
                : button === "publish"
                    ? getPublishData()
                    : button === "view"
                        ? getViewData()
                        : "";
        }
        else {
            if (!selectedRadioValue && !(selectedRadioValue === null || selectedRadioValue === void 0 ? void 0 : selectedRadioValue.value)) {
                setRadioButtonError(true);
            }
            if (!selectedDropdownValue ||
                (selectedDropdownValue && !(selectedDropdownValue === null || selectedDropdownValue === void 0 ? void 0 : selectedDropdownValue.value))) {
                setDropdownError(true);
            }
        }
    };
    return (React.createElement("div", { className: "tentative-finalPopUp" },
        loader ? React.createElement(Loader, { className: "report-view-loader" }) : React.createElement(React.Fragment, null),
        React.createElement("form", null,
            React.createElement("div", { className: " d-flex align-items-baseline mb-5" },
                React.createElement("span", { className: "DMSanN_16_400  me-3 text-nowrap" }, "EQUITY / COMMODITY"),
                React.createElement("div", null,
                    React.createElement(Select, { defaultValue: ZeroisingPopUpdropdownList[0], 
                        // isMulti
                        name: "externalParticipants", options: ZeroisingPopUpdropdownList, className: "basic-multi-select DMSanN_14_400 txt_blackOne1 equity-drop", classNamePrefix: "select", onChange: function (e) {
                            setDropdownError(false);
                            setSelectedDropdownValue(e);
                        }, closeMenuOnSelect: true }),
                    dropdownError && (React.createElement("p", { className: "help_text red d-flex align-items-center text-nowrap" }, "This field is required"))),
                React.createElement("span", { className: "ms-3" },
                    React.createElement(EdButton, { className: "text-nowrap p-2 i-beats-button", btnTyp: "midnight-blue-border", value: "Get Data From I-Beats", type: "button", onClick: function (e) {
                            e.preventDefault();
                            handleButtonClick("ibeats");
                        } }))),
            React.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center mb-5" },
                React.createElement("div", { className: "d-flex  align-items-center justify-content-center radio-block" }, zeroisingPopUpRadioList === null || zeroisingPopUpRadioList === void 0 ? void 0 : zeroisingPopUpRadioList.map(function (item, idx) {
                    return (React.createElement(RadioButton, { key: idx, list: item, name: "ZeroisingType", onChange: function (e) {
                            setRadioButtonError(false);
                            setSelectedRadioValue(item);
                        }, selected: selectedRadioValue === null || selectedRadioValue === void 0 ? void 0 : selectedRadioValue.value, className: "common-radio-button" }));
                })),
                radioButtonError && (React.createElement("p", { className: "help_text red d-flex align-items-end mt-2" }, "This field is required"))),
            React.createElement("div", { className: "d-flex flex-column align-items-center gap-3 justify-content-center  mt-5 mb-3" },
                message && (React.createElement("div", { className: "DMSanN_14_400 ".concat(isSucess ? "txt_green-link" : "txt-racing-red") }, message)),
                React.createElement("div", { className: "d-flex align-items-end button-block gap-2 justify-content-center" },
                    React.createElement(EdButton, { onClick: function (e) {
                            e.preventDefault();
                            handleButtonClick("view");
                        }, 
                        // disabled={isDownload}
                        type: "button", btnTyp: "midnight-blue", value: "View", className: "form-btn" }),
                    React.createElement(EdButton, { onClick: function (e) {
                            e.preventDefault();
                            handleButtonClick("publish");
                        }, 
                        // disabled={isDownload}
                        type: "button", btnTyp: "midnight-blue", value: "Publish", className: "form-btn" }))))));
};
export default TentativeOrFinalPopUp;
